import Swiper from 'swiper/bundle';

var sliderDesafio = document.querySelector(".slide-desafio-container")
if (sliderDesafio) {

	new Swiper(sliderDesafio, {
		slidesPerView: 1,
		spaceBetween: 32,
		centeredSlides: true,
		grabCursor: 'true',


		navigation: {
			nextEl: sliderDesafio.querySelector(".swiper-button-next"),
			prevEl: sliderDesafio.querySelector(".swiper-button-prev"),
		},
	});
}
